import { SocketEvent } from "../SocketEvent";
import { SocketEventInterface } from "../SocketEventInterface";
import { SocketEventProcessorInterface } from "../SocketEventProcessorInterface";
import Constants from "../../Action/Constants";
import ContractFactory from "../../Entity/Factories/ContractFactory";
import { ContractInterface } from "../../Entity/Entities/Contract/ContractInterface";

class ContractDelete extends SocketEvent implements SocketEventInterface {

  protected props: any;

  constructor() {
    super();
  }

  public process(props: SocketEventProcessorInterface): void {
    const contract: ContractInterface = ContractFactory.create(props.res);

    this.props.dispatch({
      type: Constants.GLOBAL_CONTRACT_DELETE_SUCCESS,
      payload: {
        contract: contract
      }
    });
  }

}

export { ContractDelete };
